import { geoConstants } from '../constants'

const initialState = {
  countryCode: '',
  languageCode: '',
  loading: false,
}

const geoReducer = (state = initialState, action) => {
  switch (action.type) {
    case geoConstants.COUNTRY_REQUEST:
      return { ...state, loading: true }
    case geoConstants.COUNTRY_FAILURE:
      return { ...state, loading: false }
    case geoConstants.COUNTRY_SUCCESS:
      return {
        ...state,
        loading: false,
        countryCode: action.response.countryCode,
        languageCode: action.response.languageCode,
      }
    default:
      return state
  }
}

export default geoReducer
